import React from 'react';

import './index.styles.scss';

export const CardJoinedOrg = ({ index, data, isSelected, onSelected }) => {
  return (
    <div
      className="card_joined_org row_align_items"
      style={
        isSelected
          ? {
              backgroundColor: 'rgba(255, 230, 242, 0.5)',
              border: '1px solid #FF3E9A'
            }
          : {}
      }
      onClick={() => {
        onSelected(data);
      }}
    >
      {data.image && data.image.startsWith('https') ? (
        <img src={data.image} className="group_image" />
      ) : (
        <div className="group_image"></div>
      )}
      <div style={{ marginLeft: 8, width: 'calc(100% - 60px)' }}>
        <div className="group_name font-bold font14">{data.name}</div>
        <div className="font-medium font12" style={{ opacity: 0.4 }}>
          {data.member_number} members
        </div>
      </div>
    </div>
  );
};
